import React from 'react';
import { Layout } from '../components/Layout';
export function EmailList() {
  return <Layout data-id="element-309">
      {/* Hero Section */}
      <section className="relative py-32 px-4 border-b border-taupe-200 overflow-hidden" data-id="element-310">
        {/* Background Image */}
        <div className="absolute inset-0" data-id="element-311">
          <img src="https://cdn.magicpatterns.com/uploads/mdfWtSHLhc955ut3dmsNVz/Join_Email_List_bg.png" alt="Down Home Interiors Storefront" className="w-full h-full object-cover object-center" data-id="element-312" />
          <div className="absolute inset-0 bg-white/80" data-id="element-313" />
        </div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-314">
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-315">
            Let's Stay in Touch!
          </h1>
          <p className="text-xl text-charcoal-900/70 leading-relaxed max-w-2xl mx-auto" data-id="element-316">
            Join our email list to receive updates on new arrivals, design tips,
            and exclusive offers.
          </p>
        </div>
      </section>

      {/* Form Section */}
      <section className="py-24 px-4 bg-white" data-id="element-317">
        <div className="max-w-2xl mx-auto" data-id="element-318">
          <div className="bg-cream-50 p-8 md:p-12 border border-taupe-200 shadow-card" data-id="element-319">
            <form action="https://www.downhomeinteriors.com/JoinEmailList.html" method="POST" className="space-y-6" data-id="element-320">
              {/* Email Field */}
              <div data-id="element-321">
                <label htmlFor="email" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-322">
                  Email <span className="text-red-500" data-id="element-323">*</span>
                </label>
                <input type="email" id="email" name="email" required className="w-full px-4 py-3 border border-taupe-300 focus:outline-none focus:ring-2 focus:ring-sage-500 focus:border-transparent transition-all" data-id="element-324" />
              </div>

              {/* First Name Field */}
              <div data-id="element-325">
                <label htmlFor="firstName" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-326">
                  First Name
                </label>
                <input type="text" id="firstName" name="firstName" className="w-full px-4 py-3 border border-taupe-300 focus:outline-none focus:ring-2 focus:ring-sage-500 focus:border-transparent transition-all" data-id="element-327" />
              </div>

              {/* Last Name Field */}
              <div data-id="element-328">
                <label htmlFor="lastName" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-329">
                  Last Name
                </label>
                <input type="text" id="lastName" name="lastName" className="w-full px-4 py-3 border border-taupe-300 focus:outline-none focus:ring-2 focus:ring-sage-500 focus:border-transparent transition-all" data-id="element-330" />
              </div>

              {/* Phone Field */}
              <div data-id="element-331">
                <label htmlFor="phone" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-332">
                  Phone
                </label>
                <input type="tel" id="phone" name="phone" className="w-full px-4 py-3 border border-taupe-300 focus:outline-none focus:ring-2 focus:ring-sage-500 focus:border-transparent transition-all" data-id="element-333" />
              </div>

              {/* Submit Button */}
              <div className="pt-4" data-id="element-334">
                <button type="submit" className="w-full bg-sage-500 text-white py-4 px-8 hover:bg-sage-600 transition-colors font-medium uppercase tracking-wide text-sm" data-id="element-335">
                  Sign Up
                </button>
              </div>
            </form>
          </div>

          <p className="text-center text-sm text-charcoal-900/60 mt-8" data-id="element-336">
            We respect your privacy and will never share your information.
          </p>
        </div>
      </section>
    </Layout>;
}